import { createContext, useContext, useEffect, useState } from "react";

export const ConsContext = createContext();

export const useCons = () => {
  const context = useContext(ConsContext);
  if (!context) throw new Error("useCons must be used within a ConsContext");
  return context;
};

export const ConsContextProvider = ({ children }) => {
  const [popActive, setPopActive] = useState({
    active: false,
  });

  useEffect(() => {
    popActive
      ? (document.querySelector("html").style.overflow = "hidden")
      : (document.querySelector("html").style.overflow = "scroll");
  }, [popActive]);

  const buttonData = (active) => {
    setPopActive({
      active: active,
    });
    try {
      dataLayer.push({
        event: "CTA",
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <ConsContext.Provider
      value={{
        popActive,
        setPopActive,
        buttonData,
      }}
    >
      {children}
    </ConsContext.Provider>
  );
};
